import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons';

type InputErrorHelperProps = {
  errorMessage: string | undefined;
};

export const InputErrorHelper = ({ errorMessage }: InputErrorHelperProps) => (
  <div className="flex flex-nowrap items-center gap-2 pt-0.5 pl-2 text-text-status-red-lighter">
    <FontAwesomeIcon className="helper-text-icon" icon={faCircleExclamation} />
    <span className="text-t14-sb">{errorMessage}</span>
  </div>
);
